/**
 * Konfiguracja pdf.js dla react-pdf.
 *
 * Worker jest ładowany **lokalnie** (żadnych CDN-ów — kancelaria pracuje on-prem),
 * z pakietu `pdfjs-dist` przypiętego do wersji używanej przez react-pdf.
 */

import { pdfjs } from 'react-pdf'
import workerSrc from 'pdfjs-dist/build/pdf.worker.min.mjs?url'

pdfjs.GlobalWorkerOptions.workerSrc = workerSrc

/** Opcje dokumentu — bez zewnętrznych zasobów (cmaps/fonty ładowane z paczki). */
export const PDF_OPTIONS = {
  isEvalSupported: false,
} as const

export { pdfjs }
